module.exports = __webpack_public_path__ + "img/greek-2.f48ffec8.svg";